export default "__VITE_ASSET__DGzEc0SH__"